import React, { useState, useEffect, useMemo } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import { DashboardProductCard } from './AgroDashboard';
import './DivisionDashboard.css';

const DivisionDashboard = ({ cart, addToCart, updateQuantity, toggleWishlist, wishlist }) => {
  const { divisionId } = useParams();
  const [products, setProducts] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState('All');

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await axios.get(`https://agro.atrmart.in/api/products`, {
          params: { division: divisionId }
        });
        setProducts(res.data.data || []);
      } catch (err) { console.error(err); }
    };
    fetchData();
  }, [divisionId]);

const divisionCategories = useMemo(() => {
  // Normalize strings: lowercase and trim whitespace
  const cats = new Set(
    products.map(p => {
      const cat = p.category ? p.category.toString().trim() : 'Uncategorized';
      return cat.charAt(0).toUpperCase() + cat.slice(1).toLowerCase(); // Ensures consistent "Fruits"
    })
  );
  return ['All', ...Array.from(cats)];
}, [products]);
const displayedProducts = selectedCategory === 'All' 
    ? products 
    : products.filter(p => {
        // Get the product category and normalize it exactly like we did in divisionCategories
        const pCat = p.category ? p.category.toString().trim() : 'Uncategorized';
        const normalizedPCat = pCat.charAt(0).toUpperCase() + pCat.slice(1).toLowerCase();
        
        return normalizedPCat === selectedCategory;
      });

      
  return (
    <div className="division-container">
      {/* Hero Header */}
{/* Professional Hero Section */}
<div className="division-hero">
  <div className="hero-content">
    <h1>{divisionId.replace('_', ' ').toUpperCase()}</h1>
    <div className="hero-divider"></div>
    <p>Handpicked, high-quality products delivered fresh to your doorstep.</p>
  </div>
</div>

      <div className="division-page-layout">
        {/* Modern Sidebar */}
        <aside className="category-sidebar">
          <h3>Filter by Category</h3>
          <div className="category-list">
            {divisionCategories.map(cat => (
              <button 
                key={cat} 
                className={selectedCategory === cat ? 'active' : ''}
                onClick={() => setSelectedCategory(cat)}
              >
                {cat}
              </button>
            ))}
          </div>
        </aside>

        {/* Product Grid */}
        <main className="product-display">
          {products.length === 0 ? (
            <div className="no-products">No products found in this division.</div>
          ) : (
            <div className="product-grid">
              {displayedProducts.map(item => (
                <DashboardProductCard 
                  key={item.id} 
                  item={item} 
                  cart={cart} 
                  addToCart={addToCart} 
                  updateQuantity={updateQuantity} 
                  toggleWishlist={toggleWishlist} 
                  isInWishlist={wishlist.some(w => w.id === item.id)} 
                />
              ))}
            </div>
          )}
        </main>
      </div>
    </div>
  );
};

export default DivisionDashboard;